import { render, staticRenderFns } from "./CategoryAdd.vue?vue&type=template&id=552350a2&scoped=true&"
import script from "./CategoryAdd.vue?vue&type=script&lang=js&"
export * from "./CategoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552350a2",
  null
  
)

export default component.exports